export default __webpack_public_path__ + "static/media/children-centre.a1e32694.JPG";